import { XCloseIcon } from '@/assets/icons';
import { AuthGlassContainer } from '@/components/common';

export const InvalidInvitation = () => {
  return (
    <AuthGlassContainer className="w-[400px] flex flex-col items-center justify-center">
      <div className="size-[50px] bg-red-darkest border border-red-base rounded-lg flex flex-row items-center justify-center">
        <XCloseIcon className="size-6 text-neutral-0" />
      </div>
      <span className="text-neutral-0 text-body-base font-semibold text-center mt-6 mb-2">
        This invitation link is invalid or has expired!
      </span>
      <span className="font-medium text-body-sm text-opacity-light-70 text-center">
        Please contact an AURA System Administrator for a new invitation.
      </span>
    </AuthGlassContainer>
  );
};
